import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

class ContentPageNavigationButton extends Component {
  render() {
    const { post } = this.props;
    return (
      <p className="mt-auto mb-0">
        <Link to={post.link} className="link-revert text-underline">
          {post.title}
        </Link>
      </p>
    );
  }
}

ContentPageNavigationButton.propTypes = {};

export default ContentPageNavigationButton;
